//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DateComp from "@/components/public/DateComp";
import ServeDialog from "@/components/statistical/ServeDialog";
export default {
  name: "AllView03",
  components: {
    DateComp: DateComp,
    ServeDialog: ServeDialog
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      startDate: "",
      endDate: "",
      deptId: "",
      pageNum: 1,
      pageSize: 20,
      total: 0,
      deptcCollege: [],
      deptcCollegeValue: "",
      headCount: {
        totalServeNum: 0,
        queryServeNum: 0,
        serveNum: 0,
        otherServerNum: 0,
        endRate: 0.0
      },
      list: []
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    // this.feacthSiftData();
    this.fetchList();
  },
  destroyed: function destroyed() {},
  methods: {
    feacthSiftData: function feacthSiftData() {
      var _this = this;

      this.loading = true;
      this.$http.post("option/query/deptcCollege").then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == "0") {
          _this.deptcCollege = data.resData.data;

          _this.$nextTick(function () {
            _this.deptcCollegeValue = data.resData.value;

            _this.initPage();
          });
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;

      this.loading = true;
      var date = this.$refs.date.getValue();
      this.$http.post("/statistical/all/byHall", JSON.stringify({
        start: date[0],
        end: date[1],
        // deptId: this.deptcCollegeValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == 0) {
          _this2.headCount.totalServeNum = data.resData.serveCountSurvey.totalServeNum;
          _this2.headCount.queryServeNum = data.resData.serveCountSurvey.queryServeNum;
          _this2.headCount.serveNum = data.resData.serveCountSurvey.serveNum;
          _this2.headCount.otherServerNum = data.resData.serveCountSurvey.otherServerNum;
          _this2.headCount.endRate = data.resData.serveCountSurvey.endRate;
          _this2.list = data.resData.countPage.list;
          _this2.total = data.resData.countPage.total;
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    initPage: function initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage: function changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    showSearchView: function showSearchView() {
      this.$refs.serveDialog.showView();
    }
  },
  watch: {},
  filters: {
    costTimeH: function costTimeH(value) {
      if (!value) return "-";
      var time = Math.floor(value / 1000);
      var day = Math.floor(time / (3600 * 24));
      var hour = Math.floor((time - day * 3600 * 24) / 3600);
      var min = Math.floor((time - day * 3600 * 24 - hour * 3600) / 60);
      var str = "";

      if (day > 0) {
        str += day + "天";
      }

      if (hour > 0) {
        str += hour + "时";
      }

      if (str == "") {
        str += min + "分";
      }

      return str;
    }
  }
};